// extracted by mini-css-extract-plugin
export default {"btnBox":"pcASaSZYkxaecKLAKpPj","applyBtn":"SqLVhFIHNZfdVJtq84Qh"};